<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { NSelect, NOption, NButton } from '@nio-fe/lego';
import { getEnvironmentFromHostname } from '@/utils';
import { $confirm, $message } from '@nio-fe/lego';
import Cookies from 'js-cookie';
import { MATE_LANE_CODE } from '@/enums';
import MicroDebugTools from '@/components/MicroDebugTools/MicroDebugTools.vue';

const lanes = ref<string[]>([]);
const hideSelect = ref<boolean>(
  localStorage?.getItem('mate-hide-lane-select') === '1'
);
const selectedLane = ref<string>(Cookies.get(MATE_LANE_CODE) || '');
const { innerWidth, innerHeight } = window;
const position = ref({ x: innerWidth - 150, y: innerHeight - 60 });
const showLaneSwitcher = computed(() => {
  return getEnvironmentFromHostname() !== 'prod';
});

watch(hideSelect, () => {
  try {
    localStorage.setItem('mate-hide-lane-select', hideSelect.value ? '1' : '0');
  } catch (e) {
    console.error('set mate-hide-lane-select error', e);
  }
});

for (let i = 1; i <= 10; i++) {
  lanes.value.push(`lane${i}`);
}

const handleLaneChange = (lane: string) => {
  $confirm(`泳道切换到${lane}, 点击确定刷新页面即可生效`, '切换泳道', {
    okText: '确认',
    cancelText: '取消',
    type: 'warning',
  })
    .then(() => {
      Cookies.set(MATE_LANE_CODE, selectedLane.value, {
        expires: 365,
      });
      $message.warning('切换泳道成功');
      window.location.reload();
    })
    .catch(() => {
      selectedLane.value = Cookies.get(MATE_LANE_CODE) || '';
      $message.warning('取消切换泳道');
    });
};
</script>

<template>
  <div
    :class="{ 'lane-switcher': true, 'lane-switcher--hide': hideSelect }"
    v-if="showLaneSwitcher"
  >
    <n-button
      size="small"
      :icon="hideSelect ? 'back' : 'next'"
      style="margin-right: 5px"
      @click="hideSelect = !hideSelect"
    ></n-button>
    <template v-if="!hideSelect">
      <n-select
        v-model="selectedLane"
        placeholder="请选择泳道"
        @change="handleLaneChange"
        size="small"
      >
        <n-option :value="''" label="主泳道"></n-option>
        <n-option
          v-for="lane in lanes"
          :value="lane"
          :key="lane"
          :label="lane"
        ></n-option>
      </n-select>
      <micro-debug-tools />
    </template>
  </div>
</template>

<style scoped lang="scss">
.lane-switcher {
  position: fixed;
  right: 10px;
  bottom: 10px;
  min-width: 180px;
  z-index: 3000;
  display: flex;
  align-items: center;
  &--hide {
    min-width: 30px;
    right: -15px;
  }
}
</style>
